import { Component, Inject, OnInit, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MemberService } from './services/Member.service';
import * as $ from 'jquery';

@Injectable()


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  title = 'app';
  UserName: string = '';
  UserCode: string = '';
  UserId: string = '';
  CompanyName: string = ''; 
  errorMessage: any;
  AdminUser: boolean = false;
  User: boolean = false;
  ngOnInit() {
    
  }

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private _memberService: MemberService,
    private _fb: FormBuilder,
    private _router: Router
  ) {
    http.get(baseUrl + 'api/Masters/GetSession').subscribe(data => {
      if (data[0].IsUser == 1) {
        this.UserName = data[0].UserName;
        this.CompanyName = data[0].CompanyName;
        this.UserCode = data[0].UserCode;
        this.UserId = data[0].UserId;

        if (data[0].UserType == "Admin") {
          //this.AdminUser = true;
          //this.User = false;
          $('.AdminUser').show();
          $('.User').hide();
        }
        else {
          //this.AdminUser = false;
          //this.User = true;
          $('.User').show();
          $('.AdminUser').hide();
        }

      }
      else {
    
        window.location.href = "Login";
      }
    }, error => console.error(error));


    $(document).ready(function () {
      $(".navp").click(function () {

        $(this).siblings(".nav-pills").toggle();

      });
    });


  }

  ChangePic(event) {
    event.target.src = "assets/UserPhoto/0.jpg";
  }



}



// WEBPACK FOOTER //
// ./src/app/app.component.ts